import React, { useContext, useEffect, useState } from "react";
import HeaderImg from "../components/HeaderImg";
import { Context } from "../context/MainContext";
import { useNavigate } from "react-router-dom";
import Profile from "./Profile";
import ChangePassword from "./ChangePassword";
import Orders from "./Orders";
import MyTrainings from "./MyTrainings";

const Account = () => {
  const query = new URLSearchParams(window.location.search);
  const tab = query.get("tab");
  const { user } = useContext(Context);

  const [view, setView] = useState(tab ? tab : "profile");
  const [headerList, setHeaderList] = useState([
    { name: "Profile", query: "profile" },
    { name: "Change Password", query: "changePassword" },
    { name: "Orders", query: "orders" },
    { name: "My Trainings", query: "enroll" },
  ]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.id) {
      navigate("/login");
    }
  }, [user?.id, navigate]);

  useEffect(() => {
    if (tab) {
      setView(tab);
    }
  }, [tab]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="account">
      <HeaderImg title="Account" />

      <div className="account__header">
        <ul className="account__header__list">
          {headerList.map((item) => {
            return (
              <li
                onClick={() => {
                  setView(item.query);
                  navigate("/account?tab=" + item?.query);
                }}
                className={view === item.query ? "active" : ""}
                key={item.query}
              >
                {item.name}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="account__main">
        {view === "profile" && <Profile />}
        {view === "changePassword" && <ChangePassword />}
        {view === "orders" && <Orders />}
        {view === "enroll" && <MyTrainings />}
        {/* {view === "Change Pasword" && <ChangePassword />} */}
        {/* <div className="account__main__details">
          <h3>Account Details</h3>
          <div className="account__main__details__info">
            <div className="account__main__details__info__item">
              First Name: <span>{user?.firstName}</span>
            </div>
            <div className="account__main__details__info__item">
              Last Name: <span>{user?.lastName}</span>
            </div>
            <div className="account__main__details__info__item">
              Email: <span>{user?.email}</span>
            </div>
          </div>
        </div>
        <div className="account__main__logout">
          <button className="btn" onClick={handleLogout}>
            Logout
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Account;
